export default __webpack_public_path__ + "static/media/Saídas.6eb96d30.svg";